import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import KudosBluredComponent from 'Shared/components/KudosBluredComponent/KudosBluredComponent';
import { viewFeedback } from 'Shared/actions/Feedbacks.actions';
import { FeedbackRecognitionType } from 'Shared/constants/types';

import './RecognitionContent.scss';

type Props = {
  feedback: FeedbackRecognitionType;
  currentUserId: number;
};

function RecognitionContent({ feedback, currentUserId }: Props) {
  const { uuid, receiverId, viewerIds, likeThatText, likeThatVideo, gifUrl } = feedback;

  const dispatch = useDispatch();

  const handleClear = useCallback(() => dispatch(viewFeedback(uuid)), [dispatch, uuid]);

  const cleared = receiverId !== currentUserId || viewerIds.includes(currentUserId);

  const onlyText = !likeThatVideo && likeThatText && !gifUrl;

  return (
    <div className={cn('d-flex my-3', { 'justify-content-center': !onlyText })}>
      <KudosBluredComponent
        erasable={receiverId === currentUserId}
        cleared={cleared}
        likeThatText={likeThatText}
        likeThatVideo={likeThatVideo}
        gifUrl={gifUrl}
        onClear={handleClear}
        onlyText={onlyText}
      />
    </div>
  );
}

export default RecognitionContent;
